package org.moxultimate.topwithmox.tech.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * TechResponse
 * Data class representing a single tech/how-to entry returned by the backend API.
 * Maps JSON fields from GET /technology and related endpoints.
 *
 * @param id          Unique database identifier.
 * @param title       Title of the tech/how-to entry.
 * @param description Short description of the entry.
 * @param type        Category type string (e.g. "Tutorial", "Guide").
 * @param tags        Comma-separated tag string for filtering/search.
 * @param thumbnailPath S3 URL of the thumbnail image.
 * @param videoLink   External video URL (YouTube or other).
 * @param createdAt   ISO-8601 creation timestamp string.
 */
@Serializable
data class TechResponse(
    @SerialName("id") val id: Long,
    @SerialName("title") val title: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("type") val type: String? = null,
    @SerialName("tags") val tags: String? = null,
    @SerialName("thumbnailPath") val thumbnailPath: String? = null,
    @SerialName("videoLink") val videoLink: String? = null,
    @SerialName("createdAt") val createdAt: String? = null,
)
